import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'ReportProblemSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReportProblemSharp.js
// module id = 5793
// module chunks = 2